export default {
  breakpoint: '40em',
};
